// protocol.ts
var MessageTypes = /* @__PURE__ */ ((MessageTypes2) => {
  MessageTypes2["GQL_START"] = "start";
  MessageTypes2["GQL_DATA"] = "data";
  MessageTypes2["GQL_ERROR"] = "error";
  MessageTypes2["GQL_STOP"] = "stop";
  MessageTypes2["GQL_COMPLETE"] = "complete";
  MessageTypes2["GQL_CONNECTION_INIT"] = "init";
  MessageTypes2["GQL_CONNECTION_ACK"] = "ack";
  MessageTypes2["GQL_CONNECTION_ERROR"] = "connection-error";
  MessageTypes2["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
  MessageTypes2["GQL_CONNECTION_CLOSE"] = "close";
  MessageTypes2["GQL_CONNECTION_ACK_CLOSE"] = "kca";
  MessageTypes2["GQL_CONNECTION_TERMINATE"] = "terminate";
  return MessageTypes2;
})(MessageTypes || {});
var TerminateReason = /* @__PURE__ */ ((TerminateReason2) => {
  TerminateReason2["RESTART"] = "restart";
  TerminateReason2["SCHEMA_REBUILD"] = "schema-rebuild";
  TerminateReason2["CONTEXT_CHANGE"] = "context-change";
  TerminateReason2["SHUTDOWN"] = "shutdown";
  TerminateReason2["CLIENT_CLOSE"] = "client-close";
  return TerminateReason2;
})(TerminateReason || {});
export {
  MessageTypes,
  TerminateReason
};
